<template>
  <el-dialog width="40%" ref="dialog" :visible.sync="localVisible" @close="close" @closed="reset">
    <div slot="title">{{ title }}</div>

    <div>
      <p>{{ message }}</p>

      <v-input-file ref="inputFile" />
    </div>

    <v-row slot="footer" justify="between">
      <v-button theme="primary" view="transparent" @click="close">{{ $t('c.dialog.buttonCancel') }}</v-button>
      <v-button
        theme="primary"
        @click="addPlacementsToListFromFile"
      >{{ $t('c.dialog.buttonUpload') }}</v-button>
    </v-row>
  </el-dialog>
</template>

<script>
import VInputFile from '@/components/common/VInputFile.vue'
import VRow from '@/components/common/VRow.vue'
import * as types from '@/store/types'
import visibleMixin from '@/mixins/visible'

export default {
  name: 'VPlacementsDialogFileUpload',

  components: {
    VInputFile,
    VRow
  },

  mixins: [visibleMixin],

  props: {
    type: {
      type: String,
      required: true,
      validator: (type) => {
        const availableTypes = [
          types.BLACKLIST_PLACEMENTS,
          types.WHITELIST_PLACEMENTS
        ]

        return availableTypes.includes(type)
      }
    },
    action: { type: String, required: true }
  },

  computed: {
    title() {
      const titles = {
        [types.BLACKLIST_PLACEMENTS]: 'c.dialog.titleAddToBlackListFromFile',
        [types.WHITELIST_PLACEMENTS]: 'c.dialog.titleAddToWhiteListFromFile'
      }

      return this.$t(titles[this.type])
    },

    listType() {
      const listTypes = {
        [types.BLACKLIST_PLACEMENTS]: 'personal_black_list',
        [types.WHITELIST_PLACEMENTS]: 'personal_white_list'
      }

      return listTypes[this.type]
    },

    message() {
      const messages = {
        [types.BLACKLIST_PLACEMENTS]: 'c.dialog.messageAddToBlackListFromFile',
        [types.WHITELIST_PLACEMENTS]: 'c.dialog.messageAddToWhiteListFromFile'
      }

      return this.$t(messages[this.type])
    }
  },

  methods: {
    reset() {
      this.$refs.inputFile.clear()
    },
    addPlacementsToListFromFile() {
      this.close()
      const { file } = this.$refs.inputFile

      if (file) {
        const { listType, action } = this

        const formData = new FormData()
        formData.append('file', file.raw)
        formData.append('type', listType)

        this.$store
          .dispatch(action, { formData })
          .then(() => this.$emit('uploaded'))
      }
    }
  }
}
</script>
